.card {
  max-width: 100%;
  animation: fadeIn 300ms ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stem {
  line-height: 1.45;
}

.questionTitle {
  line-height: 1.35;
  font-weight: 400;
}

/* Programmatically focused on each step for screen-reader orientation; it is
 * not a keyboard tab stop, so no visible focus ring is warranted. */
.questionTitle:focus {
  outline: none;
}

.option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.75rem;
  border-radius: var(--mantine-radius-md);
  cursor: pointer;
  border: none;
  background: transparent;
  width: 100%;
  text-align: left;
  font: inherit;
  font-size: var(--mantine-font-size-sm);
  color: #391640;
  transition: background-color 150ms ease;
}

.option:hover {
  background-color: var(--mantine-color-plum-0);
}

/* WCAG 2.4.7: a visible keyboard focus indicator on each answer option. */
.option:focus-visible {
  outline: 2px solid var(--mantine-color-plum-8);
  outline-offset: 2px;
}

.optionSelected {
  background-color: var(--mantine-color-plum-1);
}

.radioIndicator {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  border: 2px solid var(--mantine-color-gray-4);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 150ms ease;
}

.radioIndicatorSelected {
  border-color: var(--mantine-color-plum-8);
  background-color: var(--mantine-color-plum-8);
}

.checkmark {
  color: white;
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1;
}

.optionLabel {
  line-height: 1.4;
}

.footer {
  padding-top: var(--mantine-spacing-xs);
  border-top: 1px solid var(--mantine-color-gray-3);
}
